// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAiAdjudicationPropertyDto
 */
export interface IAiAdjudicationPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IAiAdjudicationPropertyDto
     */
    ai_adjudication_type?: IAiAdjudicationPropertyDtoAiAdjudicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAiAdjudicationPropertyDto
     */
    ai_adjudication_type_state?: IAiAdjudicationPropertyDtoAiAdjudicationTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAiAdjudicationPropertyDtoAiAdjudicationTypeEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    ORG_SETTINGS = 'ORG_SETTINGS'
}
/**
* @export
* @enum {string}
*/
export enum IAiAdjudicationPropertyDtoAiAdjudicationTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAiAdjudicationPropertyDto interface.
 */
export function instanceOfIAiAdjudicationPropertyDto(value: object): value is IAiAdjudicationPropertyDto {
    return true;
}

export function IAiAdjudicationPropertyDtoFromJSON(json: any): IAiAdjudicationPropertyDto {
    return IAiAdjudicationPropertyDtoFromJSONTyped(json, false);
}

export function IAiAdjudicationPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAiAdjudicationPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ai_adjudication_type': json['ai_adjudication_type'] == null ? undefined : json['ai_adjudication_type'],
        'ai_adjudication_type_state': json['ai_adjudication_type_state'] == null ? undefined : json['ai_adjudication_type_state'],
    };
}

export function IAiAdjudicationPropertyDtoToJSON(json: any): IAiAdjudicationPropertyDto {
    return IAiAdjudicationPropertyDtoToJSONTyped(json, false);
}

export function IAiAdjudicationPropertyDtoToJSONTyped(value?: IAiAdjudicationPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ai_adjudication_type': value['ai_adjudication_type'],
        'ai_adjudication_type_state': value['ai_adjudication_type_state'],
    };
}

